import { Component, OnInit }                from "@angular/core";
import { RouterOutlet }                     from "@angular/router";
import { fadeAnimation } from "../../animations";

@Component({
	selector: "ngx-theme-tur",
	template: `
		<div [@fadeAnimation]="prepareRoute(outlet)">
			<router-outlet #outlet="outlet"></router-outlet>
		</div>`,
	styleUrls: ["./tur.scss"],
	animations: [fadeAnimation]
})
export class ThemeTurComponent implements OnInit {

	constructor() {
	}

	ngOnInit() {
	}

	prepareRoute(outlet: RouterOutlet) {
		return outlet && outlet.activatedRouteData && outlet.activatedRouteData["animation"];
	}

}
